export default __webpack_public_path__ + "static/media/save-icon.f75c9f52.png";